import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2602_7356)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_2602_7356)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M1.63636 21H5.45455V11.7273L0 7.63635V19.3636C0 20.2691 0.733636 21 1.63636 21Z",
					fill: "#4285F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.5454 21H22.3636C23.2691 21 24 20.2664 24 19.3636V7.63635L18.5454 11.7273",
					fill: "#34A853"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.5454 4.63637V11.7273L24 7.63637V5.45455C24 3.43091 21.69 2.27728 20.0727 3.49091",
					fill: "#FBBC04"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.45456 11.7273V4.63635L12 9.54544L18.5455 4.63635V11.7273L12 16.6364",
					fill: "#EA4335"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 5.45455V7.63637L5.45455 11.7273V4.63637L3.92727 3.49091C2.30727 2.27728 0 3.43091 0 5.45455Z",
					fill: "#C5221F"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2602_7356",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_2602_7356",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 18,
			fill: "currentColor",
			transform: "translate(0 3)"
		})
	})] })]
});
export default SvgGmail;
